export const skills = [
  { name: "React (Hooks, Router, Redux Toolkit)", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-react-48.png` },
  { name: "JavaScript (ES6+, Promises, Async/Await)", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-java-script-48.png` },
  { name: "HTML (Semantic, Accessibility)", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-html-5-48.png` },
  { name: "CSS (Flexbox, Grid, BEM, Styled-components, RWD)", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-css-48.png` },
  { name: "API Integration (Fetch, Axios)", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-stackshare-50.png` },
  { name: "Three.js", icon: `${process.env.PUBLIC_URL}/skillsIcons/Three.js.png` },
  { name: "Blender", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-blender-48.png` },
  { name: "Unreal Engine", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-unreal-engine-50.png` },
  { name: "Git & GitHub (Pull Requests, Code Review)", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-git-64.png` },
  { name: "n8n", icon: `${process.env.PUBLIC_URL}/skillsIcons/n8n-color.png` },
  { name: "Make", icon: `${process.env.PUBLIC_URL}/skillsIcons/make.png` },
  { name: "WordPress & WooCommerce", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-wordpress-48.png` },
  { name: "DaVinci Resolve", icon: `${process.env.PUBLIC_URL}/skillsIcons/icons8-davinci-resolve-48.png` },
];

export const skillsToLearn = [
  "TypeScript",
  "Node.js",
  "React Context",
  "JS classes",
  "Three.js",
];
